// Lưu/đọc "level đã thấy lần trước" của từng company để phát hiện lên level.
// Tách riêng phần persistence + quyết định (pure, không React) để dễ test.

const STORAGE_PREFIX = "levelup:lastSeenLevel:";

const buildKey = (companyCode: string): string =>
  `${STORAGE_PREFIX}${companyCode}`;

/** Level đã thấy lần trước của company; null nếu chưa có / không đọc được. */
export const getLastSeenLevel = (companyCode: string): number | null => {
  if (!companyCode) return null;
  try {
    const raw = window.localStorage.getItem(buildKey(companyCode));
    if (raw == null) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    // localStorage có thể bị chặn (private mode / quyền) — bỏ qua, coi như chưa có.
    return null;
  }
};

/** Ghi lại level hiện tại làm mốc cho lần vào sau. No-op khi localStorage lỗi. */
export const setLastSeenLevel = (companyCode: string, level: number): void => {
  if (!companyCode) return;
  try {
    window.localStorage.setItem(buildKey(companyCode), String(level));
  } catch {
    // Bỏ qua khi localStorage không ghi được.
  }
};

export interface LevelUpResult {
  fromLevel: number;
  toLevel: number;
}

/**
 * Quyết định có chúc mừng lên level không, dựa trên level đã thấy và level hiện tại.
 * - lastSeen == null (lần đầu): chỉ set baseline ở phía gọi, KHÔNG popup → trả null.
 * - currentLevel > lastSeen: lên level → trả { fromLevel, toLevel }.
 * - còn lại (bằng/giảm): không popup → trả null.
 */
export const resolveLevelUp = (
  lastSeen: number | null,
  currentLevel: number,
): LevelUpResult | null => {
  if (lastSeen == null) return null;
  if (currentLevel > lastSeen) {
    return { fromLevel: lastSeen, toLevel: currentLevel };
  }
  return null;
};
